export default __webpack_public_path__ + "static/media/Bussmale.bfdd832d.png";